import { Close } from "@mui/icons-material";
import {
	Avatar,
	Box,
	Button,
	Drawer,
	FormControl,
	FormHelperText,
	IconButton,
	TextField,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Create, Update } from "../../apis/Prize";
import FormWrapper from "../Form/FormWrapper";

export const AddPrizeDrawer = ({
	edit,
	setEditOpen,
	drawerOpen,
	prize,
	setPrize,
}) => {
	const {
		register,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm();

	const [image, setImage] = useState();

	useEffect(() => {
		if (prize) {
			setImage(prize.image);
			reset({
				title: prize.title || "",
				description: prize.description || "",
				url: prize.url || "",
			});
		}
	}, [prize, reset]);

	const handleOnChange = (event) => {
		const newImage = event.target?.files?.[0];

		if (newImage) {
			setImage(URL.createObjectURL(newImage));
		}
	};
	const onSubmit = async (data) => {
		// let image = URL.createObjectURL(data.file[0]);

		const formData = new FormData();
		console.log("====================================");
		console.log(data);
		console.log("====================================");

		for (const i in data) {
			if (i === "file") {
				if (data[i].length) {
					formData.append("image", data[i][0]);
				}
			} else {formData.append(i, data[i]);}
		}

		const res = edit
			? await Update(formData, prize.id)
			: await Create(formData);

		if (res.success) {
			setPrize(res);
			setEditOpen(false);
		}
		// data.image = image;
	};

	return (
		<Drawer
			anchor="right"
			open={drawerOpen}
			onClose={() => setEditOpen(false)}
		>
			<Box
				sx={{
					width: 600,
					padding: 1,
					height: "100vh",
					overflowY: "scroll",
				}}
			>
				<IconButton
					style={{ position: "fixed" }}
					onClick={() => setEditOpen(false)}
				>
					<Close />
				</IconButton>

				<FormWrapper onSubmit={handleSubmit(onSubmit)} sx={{ p: 5 }}>
					<Box display="flex" justifyContent="space-between">
						<Typography
							variant="h6"
							gutterBottom
						>{`Give Away`}</Typography>
						<Button
							type="submit"
							// onClick={handleSave}
							color="primary"
							variant="contained"
						>
							{edit ? "Update" : "Add"}
						</Button>
					</Box>

					<Box my={3}>
						<TextField
							fullWidth
							name="title"
							// style={{ width: "100%" }}
							label="Give Away Name"
							variant="outlined"
							error={Boolean(errors.title)}
							helperText={errors.title?.message}
							{...register("title", {
								required: "Enter Prize title",
							})}
						/>
					</Box>
					<Box mb={3}>
						<TextField
							fullWidth
							name="description"
							multiline
							rows={4}
							// style={{ width: "100%" }}
							label="Description"
							variant="outlined"
							{...register("description", {
								required: "Enter description",
							})}
							error={Boolean(errors.description)}
							helperText={errors.description?.message}
						/>
					</Box>
					<Box mb={3}>
						<TextField
							fullWidth
							name="url"
							multiline
							// style={{ width: "100%" }}
							label="Enter URL"
							variant="outlined"
							{...register("url", {
								required: "Enter url",
							})}
							error={Boolean(errors.url)}
							helperText={errors.url?.message}
						/>
					</Box>

					<Box
						my={3}

					// alignItems="center"
					// minHeight="100vh"
					>
						{image && (
							<Avatar
								variant="square"
								src={image}
								sx={{
									width: 150,
									height: 150,
									objectFit: "fill",
								}}
							/>
						)}

						<FormControl error={errors.file}>
							<Button
								variant="contained"
								component="label"
								onChange={handleOnChange}
							>
								{!image ? "Upload " : "Change "}image
								<input
									hidden
									accept="image/*"
									id="file-upload"
									type="file"
									{...register("file", {
										required: {
											value: image === null,
											message: "Image required",
										},
									})}
									error={Boolean(errors.file)}
								/>
							</Button>
							{errors.file && (
								<FormHelperText>
									{errors.file?.message}
								</FormHelperText>
							)}
						</FormControl>
					</Box>
				</FormWrapper>
			</Box>
		</Drawer>
	);
};
